import React from "react";
import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import { Eye } from "lucide-react";
import { ISensorMeasuredData } from "types/ISensorMeasuredData";

interface SensorSelectorProps {
  t: (key: string, options?: Record<string, unknown>) => string;
  selectedSensors: ISensorMeasuredData[];
}

/**
 * Read-only summary of the rain sensor selection. The "Editar seleção" entry
 * is owned by the parent `SensorAlertSection` (gateway button at the top of
 * the configuration block) — keeping a second one here was redundant.
 */
export const SensorSelector: React.FC<SensorSelectorProps> = ({
  t,
  selectedSensors,
}) => {
  const sensorNames = selectedSensors.map((s) => s.station_name);
  const tooltipLabel = `${t("viewSelectedSensorsTooltip")}\n${sensorNames.join("\n")}`;

  return (
    <Flex
      align="center"
      bg="#F4F4F5"
      border="1px solid #D4D4D8"
      borderRadius="8px"
      px="12px"
      py="8px"
      gap="8px"
    >
      <Text fontSize="14px" color="#71717A" fontWeight="500">
        &bull; {t("selectedSensors", { count: selectedSensors.length })}
      </Text>
      <Tooltip
        label={<Box whiteSpace="pre-line">{tooltipLabel}</Box>}
        placement="top"
        hasArrow
        maxW="300px"
      >
        <Box
          as="span"
          cursor="pointer"
          display="flex"
          alignItems="center"
          mt="-2px"
        >
          <Eye size={20} color="#4A6075" />
        </Box>
      </Tooltip>
    </Flex>
  );
};
